import React from 'react'

export default ({icon, theme, size}) => {
  const imgUrl = `/assets/icons/${theme ? `${theme}/` : ''}${icon}.svg`

  if (size === 'large') {
    return (
      <div className="inline-block bg-white rounded-xl md:rounded-2xl lg:rounded-3xl border-black border-[3px] md:border-[6px] lg:border-[8px]">
        <img src={imgUrl} className="w-[100px] h-[100px] md:w-[120px] md:h-[120px] lg:w-[160px] lg:h-[160px]"/>
      </div>
    )
  }

  if (size === 'medium') {
    return (
      <div className="inline-block bg-white rounded-md md:rounded-lg lg:rounded-xl border-black border-[3px] md:border-[4px] lg:border-[5px]">
        <img src={imgUrl} className="w-[48px] h-[48px] md:w-[56px] md:h-[56px] lg:w-[64px] lg:h-[64px]"/>
      </div>
    )
  }

  return (
    <div className="inline-block bg-white rounded-md md:rounded-lg lg:rounded-xl border-black border-[3px] md:border-[3px] lg:border-[4px]">
      <img src={imgUrl} className="w-[32px] h-[32px] md:w-[40px] md:h-[40px] lg:w-[48px] lg:h-[48px]"/>
    </div>
  )
  // let styles = []
  // let sizes = ['30px','50px','70px']
  // let iconStyles = []

  // switch(theme) {
  //   case 'dark':
  //     styles.push('border-white')
  //   break;
  //   default:
  //     styles.push('border-black')
  // }

  // switch(size) {
  //   case 'sm':
  //     styles.push('border-[3px] md:border-[4px] lg:border-[5px]')
  //     sizes = ['30px','50px','70px']
  //     break;
  //   default:
  //     styles.push('border-[3px] md:border-[4px] lg:border-[5px]')
  //     sizes = ['40px','50px','60px']
  // }


  // const baseStyles = `inline-block rounded-2xl mx-auto mb-2`
  // styles.push(baseStyles)

  // return (
  //   <div className={styles.join(' ')}>
  //     <img src={`/assets/icons/${icon}.svg`} className={`w-[${sizes[0]}] h-[${sizes[0]}] md:w-[${sizes[1]}] md:h-[${sizes[1]}] lg:w-[${sizes[2]}] lg:h-[${sizes[2]}]`} />
  //   </div>
  // )
}